// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../engines/components/BaseComponent";
import BaseStatePlusSprite from "../../../../engines/components/state/BaseStatePlusSprite";
import O1HD from "../../../../engines/gameEngine";
import EscortGoods1GameLayer from "./EscortGoods1GameLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class EscortGoods1GamePeople extends BaseComponent {

	@property({ type: cc.Node, displayName:'' })
	btnClick: cc.Node = null;

	@property({ type: BaseStatePlusSprite, displayName:'' })
	sprPeople: BaseStatePlusSprite = null;


    private bBandit = false;
    private _parent: EscortGoods1GameLayer = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        // this.btnClick.active = false;
        // this.sprPeople.node.active = false;
    }

    startArise(
        bBandit: boolean
        , showTime: number
        , _parent: EscortGoods1GameLayer
    ) {
        this._parent = _parent;
        this.sprPeople.node.active = true;
        this.bBandit = bBandit;
        let idx = bBandit ? 0 : 2;
        this.sprPeople.setFill(idx);
        
        let height = this.sprPeople.node.height;
        this.sprPeople.node.y = -height;

        this.btnClick.active = false;
        cc.Tween.stopAllByTarget(this.sprPeople.node);
        cc.tween(this.sprPeople.node)
        .to(0.25, {
            y: 0
        })
        .call(()=> {
            this.btnClick.active = true;
        })
        .delay(showTime)
        .call(()=> {
            this.btnClick.active = false;
            if (bBandit && this._parent) {
                this._parent.letOffBandit();
            }
        })
        .to(0.25, {
            y: -height
        })
        .start();
    }

    onClickHit() {
        O1HD.getManagers().soundMgr.playSound("escort_goods_kill");
        let idx = this.bBandit ? 1 : 3;
        let height = this.sprPeople.node.height;
        this.btnClick.active = false;
        this.sprPeople.setFill(idx);

        if (this._parent) {
            if (this.bBandit) {
                this._parent.killBandit();
            } else {
                this._parent.killCivilian();
            }
        }
        
        cc.Tween.stopAllByTarget(this.sprPeople.node);
        cc.tween(this.sprPeople.node)
        .delay(1.5)
        .to(0.01, {
            y: -height
        })
        .start();
    }


    // update (dt) {}
}
